module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAQCAYAAAD9L+QYAAABZ0lEQVQ4T7XUMUvDUBAH8P8VLM4KhYyC+g2EuOhgwclZcKiow3tkCLoLFt1dm7ShdRC6imMduiiK36CDXUUUXJu0fScvGIm1bWpJs+Vx/18udyGECS7P85Z7vV6ViNaY+VkpdWBZVjspSkkFpVIpl8lkngAsRbXM3A6CwLRt+31cfixeq9Xmfd9vEpE5iBDRQ6fT2bJt2x/1gHE4ua5bB7A7KszMdSnl3r/xcrl8wcynSWNj5nMp5dmwuqGdVyqVglLqCkDiTgAwMxeklNd/Rjd44DjOBhHdAcgmdR1bsE9EeSHEfTzzqzPHcVaI6BHA4qRwrO4DgCmEeInOfnDP8xb6/b6GV6eAwwgzt5RS65Zlfer7EC8Wi1nDMBoANqeFY7kmgG0hRDfEXdfVy9tPAY6IqhDiSH/LJwAuU4SjER1r/A1ALm0cwKvGAwBzM8ADjd8C2JkBfkPffz290HxKb9AF0FBKHX4BrpGIEo2OiF0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/up1.png
// module id = 6kDS
// module chunks = 1